<template>
<footer class="footer">
  <div class="wrap wrap-wide">
    <div class="fgrid">
      <div class="fcol fabout">
        <router-link class="brand" to="/"><img src="@/assets/images/logo_new.png" alt="UnionWallex" style="height: 76px; width: auto; object-fit: contain; display: block;" /></router-link>
        <p v-html="$t('f_desc')"></p>
        <div class="chips">
          <span class="chip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 3.5v6c0 5-3.4 9.3-8 10.5-4.6-1.2-8-5.5-8-10.5v-6L12 2z"/></svg> <span v-html="$t('f_chip1')"></span></span>
          <span class="chip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.5 2.7 3.8 6 3.8 9S14.5 18.3 12 21c-2.5-2.7-3.8-6-3.8-9S9.5 5.7 12 3z"/></svg> <span v-html="$t('f_chip2')"></span></span>
        </div>
      </div>
      <div class="fcol">
        <h5 v-html="$t('f_sol')"></h5>
        <router-link to="/acquiring" v-html="$t('dd_acq_t')"></router-link>
        <router-link to="/card" v-html="$t('dd_card_t')"></router-link>
        <router-link to="/payout" v-html="$t('dd_pay_t')"></router-link>
        <router-link to="/platform" v-html="$t('dd_plat_t')"></router-link>
        <router-link to="/integration" v-html="$t('dd_int_t')"></router-link>
      </div>
      <div class="fcol">
        <h5 v-html="$t('f_res')"></h5>
        <router-link to="/docs#acquiring" v-html="$t('dd_docacq_t')"></router-link>
        <router-link to="/docs#payment" v-html="$t('dd_docpay_t')"></router-link>
        <router-link to="/docs#subscription" v-html="$t('dd_docsub_t')"></router-link>
        <router-link to="/help" v-html="$t('dd_help_t')"></router-link>
      </div>
      <div class="fcol">
        <h5 v-html="$t('f_company')"></h5>
        <router-link to="/about" v-html="$t('dd_intro_t')"></router-link>
        <router-link to="/about#compliance" v-html="$t('dd_comp_t')"></router-link>
        <router-link to="/contact" v-html="$t('dd_contact_t')"></router-link>
      </div>
      <div class="fcol">
        <h5 v-html="$t('f_follow')"></h5>
        <a href="mailto:office@unionwallex.com">office@unionwallex.com</a>
        <a href="tel:+85297168609">+852 9716-8609</a>
        <router-link to="/privacy" v-html="$t('pv_title')"></router-link>
        <router-link to="/terms" v-html="$t('tm_title')"></router-link>
      </div>
    </div>
    <p class="fdisc" v-html="$t('f_disc')"></p>
    <div class="fbottom">
      <span v-html="$t('f_rights')"></span>
      <span class="fl">
        <router-link to="/privacy" v-html="$t('pv_title')"></router-link>
        <router-link to="/terms" v-html="$t('tm_title')"></router-link>
        <router-link to="/contact" v-html="$t('nav_contact')"></router-link>
      </span>
    </div>
  </div>
</footer>
</template>
